import stats from 'stats-js';
import browser from 'browser-detect';
//test fps
import $ from 'jquery';
require('bootstrap');
import niceScroll from 'jquery.nicescroll';
import slick from 'slick-carousel';
import ScrollMagic from 'scrollmagic';
import {
  TweenLite
} from 'gsap';

import News from './pages/News';
import Production from './pages/Production';
import Production1 from './pages/Production1';
import IndexContent from './pages/IndexContent';
import Bonus from './pages/Bonus';
import Store from './pages/Store';

let pageName;
let hash;
let host;
// let sm, prodId;

export default class App {
  constructor() {}
  init() {

    this.browser = browser();
    // this.initStats();
    this.page = "";


    if(window.location.host == "localhost:8080"){
      this.host = "http://test.japlo.com.tw/"
      // console.log("localhost")
    }
    else{
      this.host = "./";
      // console.log("online")
    }
    // this.host = "http://ec2-54-238-37-155.ap-northeast-1.compute.amazonaws.com/"

    // this.host = "./";
    host = this.host;
    this.buildNav();
    this.initPages();
    this.addListeners();
    this.initContact();
  }
  initContact() {
    $('.contact .button').click(function() {

      var sName = $('.contact__name').val();
      var sTel = $('.contact__tel').val();
      var sEmail = $('.contact__email').val();
      var sType = $('.contact__select').val();
      var sContent = $('.contact__question').val();
      var sJson = {
        name: sName,
        phone: sTel,
        email: sEmail,
        subject: sType,
        content: sContent,
      };
      // console.log(sJson);
      $.ajax({
        type: "post",
        async: false,
        dataType: "json",
        url: host + "api/contactus/new",
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: sJson,
        success: function(msg) {
          // console.log('gj', msg)

          //do something
        },
        statusCode: {
          200: function(su) {
            // console.log(su)
            alert('已完成送出');

          },
          400: function(response) {
            // console.log(response);
            var errorMsg = JSON.parse(response.responseText);
            console.log(errorMsg.msg);
            var msg = "";
            var obj = errorMsg.msg;
            for (var x in obj) {
              msg += obj[x];
            }
            console.log(msg);
            alert('error:' + msg);
          }
        }
      });
    })
  }
  openMenu() {
    $('button.hamburger').addClass('is-active');
    $('.menu').addClass('is-active');
    $('.nav__info').addClass('is-active');
  }
  closeMenu() {
    $('button.hamburger').removeClass('is-active');
    $('.menu').removeClass('is-active');
    $('.nav__info').removeClass('is-active');
  }
  buildNav() {
    $('footer').append('' +
      '<p class="text-center">佳兒樂健康事業有限公司<br />2020 © Yuan Ning Trading , All Rights Reserved.</p>'
    );

    $('header').append('' +
      '<nav>' +
      '<ul class="menu">' +
      '<li class="menu__item"><a href="about.html">關於我們</a></li>' +
      '<li class="menu__item"><a href="news.html">最新消息</a></li>' +
      '<li class="menu__item"><a href="production.html">商品介紹</a></li>' +
      '<li class="menu__item"><a href="bonus.html">紅利積點</a></li>' +
      '<li class="menu__item"><a href="store.html">經銷查詢</a></li>' +
      '<li class="menu__item"><a href="contact.html">聯絡我們</a></li>' +
      '</ul>' +
      '<div class="logo">' +
      '<a href="index.html">' +
      '<img src="assets/images/header_logo.png" alt="logo">' +
      '</a>' +
      '</div>' +
      '<ul class="nav__info">' +
      '<li><a href="tel:0800088178">免付費電話：0800-088-178</a></li>' +
      '<li><a href="mailto:yuan6106@ms24.hinet.net">電子信箱：yuan6106@ms24.hinet.net</a></li>' +
      '</ul>' +
      '<button class="hamburger hamburger--slider" type="button">' +
      '<span class="hamburger-box">' +
      '<span class="hamburger-inner"></span>' +
      '</span>' +
      '</button>' +
      '</nav>'
    );
    $('button.hamburger').click(function() {
      if ($('button.hamburger').hasClass('is-active')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }.bind(this));

  }
  initPages() {

    this.getHash();

    var path = window.location.pathname;
    pageName = path.split("/").pop();
    // console.log(pageName);
    switch (pageName) {
      case '':
        this.indexContent = new IndexContent(this);
        break;
      case 'index.html':
        this.indexContent = new IndexContent(this);
        break;
      case 'news.html':
        this.news = new News(this);
        break;
      case 'store.html':
        this.store = new Store(this);
        break;
      case 'production.html':
        this.production = new Production(this);
        break;
      case 'production_1.html':
        this.production1 = new Production1(this);
        break;
      case 'bonus.html':
        this.bonus = new Bonus(this);
        break;
    }
    this.showPage();
  }
  initNav() {

  }
  initSlider() {

  }
  //init Stats
  initStats() {
    this.stats = new stats();
    this.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
    document.body.appendChild(this.stats.dom);
  }

  addListeners() {
    this.handlerAnimate = this.animate.bind(this);
    window.addEventListener('resize', this.resize.bind(this));
    window.addEventListener('keyup', this.keyup.bind(this));
    window.addEventListener('mousemove', this.mousemove.bind(this));
    window.addEventListener('click', this.click.bind(this));
    window.addEventListener('mouseup', this.mouseup.bind(this));
    window.addEventListener('touchend', this.mouseup.bind(this));
    window.addEventListener("hashchange", this.funcRef.bind(this), false);
  }


  // ---------------------------------------------------------------------------------------------
  // PUBLIC
  // ---------------------------------------------------------------------------------------------
  animate() {
    if (this.stats) this.stats.begin();
    this.update();
    if (this.stats) this.stats.end();
    this.raf = requestAnimationFrame(this.handlerAnimate);
  }
  update() {

  }

  // ---------------------------------------------------------------------------------------------
  // EVENT HANDLERS
  // ---------------------------------------------------------------------------------------------
  getHash() {
    this.sm = "";
    this.prodId = "";

    hash = window.location.hash.substr(1);
    var hashArr = hash.split('?');
    this.hash = hashArr[0];
    var val = window.location.href;
    if (val.indexOf('?') != -1) {
      var ary1 = val.split('?');
      var ary2 = ary1[1].split('&');
      // console.log(ary2);
      for (var i = 0; i < ary2.length; i++) {
        var ary3 = ary2[i].split('=');
        // console.log(ary3);
        if (ary3[0] == "sm") {
          // console.log('sm', ary3[1]);
          this.sm = ary3[1];
        } else if (ary3[0] == 'id') {
          this.prodId = ary3[1];
        }
      }
    }
  }
  funcRef() {
    this.showPage();

    if (this.news) this.news.hashchange(hash);
    if (this.bonus) this.bonus.hashchange(hash);
    if (this.production) this.production.hashchange(hash);
    if (this.production1) this.production1.hashchange(hash);
    if (this.cooperation) this.cooperation.hashchange(hash);
    if (this.store) this.store.hashchange(hash);

  }
  showPage() {

    this.getHash();

    if (this.hash != '') {
      $('.page-content').hide();
      $('.page-content.' + this.hash).show();
      $('.hashlink__item').removeClass('is-active');
      // console.log(this.hash);
      // console.log($('.hashlink__item[href="#'+this.hash+'"]'))
      if ($('.hashlink__item[href="#' + this.hash + '"]').hasClass('is-active')) {

      } else {
        $('.hashlink__item[href="#' + this.hash + '"]').addClass('is-active')
      }
    } else {
      $('.page-content').hide();
      $('.page-content.index').show();
    }

    // var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
    // $body.animate({
    //   scrollTop: 0
    // }, 600);
  }
  updatePage() {

    if (this.hash !== '') {
      $('.page-content').hide();
      $('.page-content.' + this.hash).show();
      // $('.hashlink__item').removeClass('is-active');
      // console.log(this.hash);
      // console.log($('.hashlink__item[href="#'+this.hash+'"]'))
      // if ($('.hashlink__item[href="#' + this.hash + '"]').hasClass('is-active')) {
      //
      // } else {
      //   $('.hashlink__item[href="#' + this.hash + '"]').addClass('is-active')
      // }
    } else {
      $('.page-content').hide();
      $('.page-content.index').show();
    }
  }
  resize() {}

  keyup(e) {

  }
  mouseup(e) {

  }
  mousemove(e) {

  }

  click(e) {

  }
}
